// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3qYN5","errorLogs":"styles_errorLogs__kQrqo"};